export function Cart() {
	this.cartedProducts = [],
	this.shippingId = null,
	this.paymentId = null,
	this.remarks = null,
	this.storeId = null
}